import { INetworkDevice } from '@core/interfaces/network-devices-items';

export enum CatoSubnetRangeTypeEnum {
  Direct = 'direct',
  Routed = 'routed',
  Vlan = 'vlan',
  Native = 'native',
}
export enum CatoSubnetDhcpTypeEnum {
  Disabled = 'dhcp_disabled',
  AccountDefault = 'account_default',
  Range = 'dhcp_range',
  Relay = 'dhcp_relay',
}

export const CATO_SUBNET_RANGE_TYPE_OPTIONS = [
  { key: CatoSubnetRangeTypeEnum.Direct, value: 'Direct' },
  { key: CatoSubnetRangeTypeEnum.Routed, value: 'Routed' },
  { key: CatoSubnetRangeTypeEnum.Vlan, value: 'VLAN' },
  { key: CatoSubnetRangeTypeEnum.Native, value: 'Native' },
];

export const CATO_SUBNET_DHCP_TYPE_OPTIONS = [
  { key: CatoSubnetDhcpTypeEnum.Disabled, value: 'No DHCP' },
  { key: CatoSubnetDhcpTypeEnum.AccountDefault, value: 'Account Default' },
  { key: CatoSubnetDhcpTypeEnum.Range, value: 'DHCP Range' },
  { key: CatoSubnetDhcpTypeEnum.Relay, value: 'DHCP Relay' },
];

export type TCatoSubnetInterface = 'LAN1' | 'LAN2';

export const CATO_SUBNET_INTERFACE_OPTIONS: { key: TCatoSubnetInterface; value: string }[] = [
  { key: 'LAN1', value: 'LAN1' },
  { key: 'LAN2', value: 'LAN2' },
];

export interface ICatoSubnet {
  id: number;
  address: string;
  dhcp_type: CatoSubnetDhcpTypeEnum;
  gateway_address: string;
  interface: TCatoSubnetInterface;
  internet_only: boolean;
  name: string;
  range_end: string;
  range_start: string;
  range_type: CatoSubnetRangeTypeEnum;
  relay_group: number;
  subnet: string;
  vlan: number;
  cato_id?: string;
  network_device: INetworkDevice;
}
